import styled from '@emotion/styled';
import ComponentContainer from '../../components/Container';

export const Container = styled(ComponentContainer)`
  margin-bottom: ${({ theme }) => theme.functions?.toEm(15)};
`;
